<template>
  <Dropdown v-bind="value" :options="options" optionLabel="name" optionValue="id" appendTo="body" showClear
    :loading="loading" class="dropdown-extra" @change="onChange">
    <template #value>
      <img :src="`/images/24x24/${current.image_index}.png`" width="17" class="mr-1" v-if="current.image_index" />
      <div :style="[style, 'font-weight:' + fontStyle]">{{ current.name }}</div>
    </template>
    <template #option="slotProps">
      <div class="container">
        <img class="block" :src="`/images/24x24/${slotProps.option.image_index}.png`" width="18"
          v-if="slotProps.option.image_index" />
        <span class="block ml-1" :style="style">{{ slotProps.option.name }}</span>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "dropdown_",
  mixins: [MixinStates],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    function: {
      type: Function,
    },
  },
  data() {
    return { style: {}, loading: false };
  },
  methods: {
    onChange(event) {
      if (this.function && this.$store.getters.info.isControl) {
        const funct = this.function(event);
        if (this.isPromise(funct)) {
          this.loading = true;
          funct.finally(() => this.loading = false)
        }
      }
    },
    isPromise(promise) {
      return promise instanceof Promise || (Boolean(promise) && typeof promise.then === 'function');
    }
  },
  mounted() {
    this.style = {
      "font-size": (localStorage.scale ? localStorage.scale : 13) - 1 + "px",

    };
  },
  computed: {
    value: function () {
      if (typeof this.properties[this.PropertyURI] == "undefined") {
        return null;
      } else {
        return this.properties[this.PropertyURI].outputValue.value;
      }
    },
    current: function () {
      const index = this.options.findIndex((item) => Number(item.id) == this.value);
      return index > -1 ? this.options[index] : {};
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep(.p-dropdown-label) {
  display: flex;
  align-items: center;
  background-color: white;
}

.dropdown-extra {
  border-radius: 0px !important;
  border-color: #B9B9B9;
  z-index: 2;
}

.container {
  display: flex;
}
</style>
